import React from 'react';

import { Loader2 } from 'lucide-react';

export const Spinner = ({ height = 200 }) => (
  <div className="flex flex-1 items-center justify-center" style={{ height: `${height}px` }}>
    <Loader2 className="h-12 w-12 animate-spin text-primary-600"/>
  </div>
);

export default Spinner;
